import { render, staticRenderFns } from "./ContabilitaDocumentoRigheEditComponentN.vue?vue&type=template&id=ecc2704a&scoped=true"
import script from "./ContabilitaDocumentoRigheEditComponentN.vue?vue&type=script&lang=js"
export * from "./ContabilitaDocumentoRigheEditComponentN.vue?vue&type=script&lang=js"
import style0 from "./ContabilitaDocumentoRigheEditComponentN.vue?vue&type=style&index=0&id=ecc2704a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc2704a",
  null
  
)

export default component.exports